export const MESSAGES = {
  en: {
    // SidePanel
    lines: "Metro Lines",
    purpleLine: "Purple Line",
    yellowLine: "Yellow Line",
    greenLine: "Green Line",
    showAll: "Show All",
    hideAll: "Hide All",
    marquee: "Please note: Train times shown are estimated and may change based on real-time updates.",
    comingSoon: "Coming Soon",

    // Favorites
    favourites: "Favourites",
    noFav: "No favourites set",
    addFav: "Add Favourite Station",
    addFavStop: "Add Favourite Stop",
    line: "Line",
    stop: "Stop",
    cancel: "Cancel",
    save: "Save",
    arriving: "ARRIVING",
    select: "-- Select --",

    // Marquee
    controls: "Controls",
    appTitle: "Sanchaara",
    aboutMessage: "Bangalore Metro Live Tracking",

    close: "Close",

    about_title: "About Namma Metro Live",
    about_intro:
      "Sanchaara is an independent site that visualizes live-like train movement for Bengaluru’s metro. At present, the site supports the Yellow Line only. Trains are animated from published schedules and station coordinates to help commuters understand how services flow along the corridor.",
    about_what_title: "What this site does",
    about_what_body:
      "The map displays the Yellow Line with station markers, trip timings, and animated train positions derived from official timetables. It is a visualization, not real-time GPS tracking.",
    about_status_title: "Status and roadmap",
    about_status_body:
      "Yellow Line is available today. Support for the Purple and Green Lines is planned and will be added soon.",
    about_affiliation_title: "Affiliation",
    about_affiliation_body:
      "Sanchaara is not affiliated with BMRCL. All data and visuals are for informational purposes only.",
    about_contact_title: "Contact",
    about_contact_body: "Questions or suggestions? Email:",
    disclaimer:
      "Metro timings shown are approximate and may vary due to real-time operational updates.",
  },
  hi: {
    lines: "लाइनें",
    purpleLine: "बैंगनी लाइन",
    yellowLine: "पीली लाइन",
    greenLine: "हरी लाइन",
    showAll: "सभी दिखाएँ",
    hideAll: "सभी छुपाएँ",
    marquee: "कृपया ध्यान दें: प्रदर्शित ट्रेन समय अनुमानित हैं और वास्तविक समय के अद्यतनों के आधार पर बदल सकते हैं।",

    favourites: "पसंदीदा",
    noFav: "कोई पसंदीदा नहीं",
    addFav: "पसंदीदा स्टेशन जोड़ें",
    addFavStop: "पसंदीदा स्टॉप जोड़ें",
    line: "लाइन",
    stop: "स्टॉप",
    cancel: "रद्द करें",
    save: "सेव",
    arriving: "ARRIVING",
    select: "-- चुनें --",
    comingSoon: "Coming Soon",

    controls: "नियंत्रण",
    appTitle: "नम्मा मेट्रो लाइव",
    aboutMessage: "हमारे बारे में - नम्मा मेट्रो लाइव",
    close: "बंद करें",

    about_title: "नम्मा मेट्रो लाइव के बारे में",
    about_intro:
      "नम्मा मेट्रो लाइव एक स्वतंत्र साइट है जो बेंगलुरु मेट्रो के लिए लाइव जैसी ट्रेन मूवमेंट को दर्शाती है। फिलहाल, साइट केवल पीली लाइन का समर्थन करती है। ट्रेनें प्रकाशित समय-सारिणी और स्टेशन निर्देशांकों से एनीमेट की जाती हैं ताकि यात्री कॉरिडोर पर सेवाओं के प्रवाह को समझ सकें।",
    about_what_title: "यह साइट क्या करती है",
    about_what_body:
      "मानचित्र पीली लाइन को स्टेशन मार्करों, यात्रा समय और आधिकारिक समय-सारिणी से निकली एनीमेटेड ट्रेन स्थितियों के साथ दिखाता है। यह एक विज़ुअलाइज़ेशन है, वास्तविक समय GPS ट्रैकिंग नहीं।",
    about_status_title: "स्थिति और रोडमैप",
    about_status_body:
      "आज पीली लाइन उपलब्ध है। बैंगनी और हरी लाइनों के लिए समर्थन की योजना है और इसे जल्द जोड़ा जाएगा।",
    about_affiliation_title: "संबद्धता",
    about_affiliation_body:
      "नम्मा मेट्रो लाइव, BMRCL से संबद्ध नहीं है। सभी डेटा और दृश्य केवल जानकारी के लिए हैं।",
    about_contact_title: "संपर्क",
    about_contact_body: "प्रश्न या सुझाव? ईमेल करें:",
    disclaimer:
      "मेट्रो के समय अनुमानित हैं और वास्तविक समय के संचालन अद्यतनों के अनुसार बदल सकते हैं।",
  },
  kn: {
    lines: "ಮಾರ್ಗಗಳು",
    purpleLine: "ನೇರಳೆ ಮಾರ್ಗ",
    yellowLine: "ಹಳದಿ ಮಾರ್ಗ",
    greenLine: "ಹಸಿರು ಮಾರ್ಗ",
    showAll: "ಎಲ್ಲವನ್ನೂ ತೋರಿಸಿ",
    hideAll: "ಎಲ್ಲವನ್ನೂ ಮರೆಮಾಡಿ",
    marquee: "ದಯವಿಟ್ಟು ಗಮನಿಸಿ: ತೋರಿಸಲಾದ ರೈಲು ಸಮಯಗಳು ಅಂದಾಜು ಆಗಿದ್ದು, ನಿಜ ಸಮಯದ ನವೀಕರಣಗಳ ಆಧಾರದ ಮೇಲೆ ಬದಲಾಗಬಹುದು.",

    favourites: "ಆಸಕ್ತಿಗಳು",
    noFav: "ಯಾವುದೇ ಆಸಕ್ತಿ ಇಲ್ಲ",
    addFav: "ಆಸಕ್ತ ನಿಲ್ದಾಣ ಸೇರಿಸಿ",
    addFavStop: "ಆಸಕ್ತ ನಿಲ್ದಾಣ ಸೇರಿಸಿ",
    line: "ಮಾರ್ಗ",
    stop: "ನಿಲ್ದಾಣ",
    cancel: "ರದ್ದುಮಾಡಿ",
    save: "ಉಳಿಸಿ",
    arriving: "ಬರುತ್ತಿದೆ",
    select: "-- ಆಯ್ಕೆಮಾಡಿ --",
    comingSoon: "Coming Soon",

    controls: "ನಿಯಂತ್ರಣಗಳು",
    appTitle: "ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್",
    aboutMessage: "ನಮ್ಮ ಬಗ್ಗೆ - ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್",
    close: "ಮುಚ್ಚಿ",

    about_title: "ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್ ಬಗ್ಗೆ",
    about_intro:
      "ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್ ಸ್ವತಂತ್ರ ತಾಣವಾಗಿದೆ. ಇದು ಬೆಂಗಳೂರಿನ ಮೆಟ್ರೊಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ನೈಜ ಕಾಲದಂತಿರುವ ರೈಲು ಚಲನವಲನವನ್ನು ದೃಶ್ಯೀಕರಿಸುತ್ತದೆ. ಪ್ರಸ್ತುತ, ತಾಣದಲ್ಲಿ ಹಳದಿ ಮಾರ್ಗ ಮಾತ್ರ ಲಭ್ಯ. ಪ್ರಕಟಿತ ಕಾಲಪಟ್ಟಿ ಮತ್ತು ನಿಲ್ದಾಣ ಸಮನ್ವಯಗಳನ್ನು ಆಧರಿಸಿ ರೈಲುಗಳ ಚಲನೆ ಅನಿಮೇಟ್ ಮಾಡಲಾಗುತ್ತದೆ.",
    about_what_title: "ತಾಣ ಏನು ಮಾಡುತ್ತದೆ",
    about_what_body:
      "ನಕ್ಷೆಯಲ್ಲಿ ಹಳದಿ ಮಾರ್ಗವನ್ನು ನಿಲ್ದಾಣ ಗುರುತುಗಳು, ಪ್ರಯಾಣ ಸಮಯ ಮತ್ತು ಅಧಿಕೃತ ಕಾಲಪಟ್ಟಿಯಿಂದ ದೊರಕಿದ ಅನಿಮೇಟ್ ರೈಲು ಸ್ಥಾನದೊಂದಿಗೆ ತೋರಿಸಲಾಗುತ್ತದೆ. ಇದು ದೃಶ್ಯೀಕರಣ; ನೈಜ ಕಾಲ GPS ಟ್ರ್ಯಾಕಿಂಗ್ ಅಲ್ಲ.",
    about_status_title: "ಸ್ಥಿತಿ ಮತ್ತು ರಸ್ತೆನಕ್ಷೆ",
    about_status_body:
      "ಇಂದು ಹಳದಿ ಮಾರ್ಗ ಲಭ್ಯ. ನೇರಳೆ ಮತ್ತು ಹಸಿರು ಮಾರ್ಗಗಳ ಬೆಂಬಲ ಶೀಘ್ರದಲ್ಲೇ ಸೇರಿಸಲಾಗುತ್ತದೆ.",
    about_affiliation_title: "ಸಂಸ್ಥೆ ಸಂಬಂಧ",
    about_affiliation_body:
      "ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್, BMRCL ಗೆ ಸಂಬಂಧಪಟ್ಟದ್ದಲ್ಲ. ಎಲ್ಲಾ ಡೇಟಾ ಮತ್ತು ದೃಶ್ಯಗಳು ಮಾಹಿತಿ ಉದ್ದೇಶಕ್ಕಾಗಿ ಮಾತ್ರ.",
    about_contact_title: "ಸಂಪರ್ಕ",
    about_contact_body: "ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಸಲಹೆಗಳು? ಇಮೇಲ್:",
    disclaimer:
      "ತೋರಿಸಲಾದ ಮೆಟ್ರೊ ಸಮಯಗಳು ಅಂದಾಜು ಆಗಿದ್ದು, ನೈಜ ಸಮಯದ ಕಾರ್ಯಾಚರಣೆ ನವೀಕರಣಗಳ ಆಧಾರದ ಮೇಲೆ ಬದಲಾಗಬಹುದು.",
  },
};

export function t(lang = "en") {
  return MESSAGES[lang] || MESSAGES.en;
}
